var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.sale)?_c('search-component',{staticClass:"m-l-15",attrs:{"id":"select_client_devoluciones","prop":{text: 'Cliente', key: 'client_id'},"model":_vm.client,"model_name":"client","set_selected_model_with_model_prop":"","props_to_filter":['num', 'name', 'phone']},on:{"setSelected":_vm.setSelected,"clearSelected":_vm.clearSelected}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }